export const roomConfigurePositions = {
    topRight: [
        600,
        200,
    ],
    centerLeft: [
        200,
        400,
    ],
    centerRight: [
        600,
        400,
    ],
    bottomLeft: [
        200,
        600,
    ],
    bottomCenter: [
        400,
        600,
    ],
    bottomRight: [
        600,
        600,
    ],
    backRightWall: [
        0,
        0,
    ],
};
